<template>
  <div class="">
    <div class="w-full flex text-c14 font-c4 text-left items-center item cursor-pointer pr-6">
      <div class="w-1/6">
        {{ new Date(item.created_at).toLocaleString() }}
      </div>

      <div class="w-1/6 ml-4">
        <span v-if="item.type === 'CASH'">Espèce</span>
        <span v-if="item.type === 'MOBILE_MONEY'">Mobile Money</span>
        <span v-if="item.type === 'BANK_CHECK'">Chèque</span>
      </div>

      <div class="w-1/6 ml-4">
        {{ item.control_by.fullname }}
      </div>

      <div class="w-1/6 ml-4">
        {{ item.meta.theoriqueAmount.toLocaleString() }} fcfa
      </div>


      <div class="w-1/6 ml-4">
        {{ item.meta.reelAmount.toLocaleString() }} fcfa
      </div>

      <div class="w-1/6 ml-4">
        {{ item.meta.diferentiel.toLocaleString() }} fcfa
      </div>

      <div class="w-1/6 ml-4">
        <div class="text-c16">
          {{ item.wallet.agency.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import entreprise from '../../../assets/icons/entreprise.svg'
import email from '../../../assets/icons/email.svg'
import down from '../../../assets/icons/down.svg'

export default {
  name: "Index",
  components: {
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      icons: {
        entreprise,
        email,
        down
      },
    }
  },

  computed: {
    amount: function () {
      let amount = (this.item.financialData.totalAmount + this.item.financialData.deliveryAmount)-(this.item.financialData.discountAmount + this.item.financialData.supportAmount)
      return amount.toLocaleString()
    }
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
.svg-icon{
  fill: transparent;
}
.item:hover{
  border-left: 3px groove black;
  padding-left: 30px;
}
</style>
